// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Fxqxm","tab":"Tabs_tab__20hnt","tabActive":"Tabs_tabActive__UiCbg"};